<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  getDayDifferenceFromNow,
  relativeDayTimestamp,
} from 'shared/helpers/timeHelper';

const props = defineProps({
  timestamp: { type: Number, required: true },
});

const { t } = useI18n();

const label = computed(() => {
  if (getDayDifferenceFromNow(new Date(), props.timestamp) <= 0)
    return t('BONBOZ.TIN_NHAN.HOM_NAY');

  return relativeDayTimestamp(props.timestamp, t('BONBOZ.TIN_NHAN.HOM_QUA'));
});
</script>

<template>
  <!-- BonBoZ: vách phải chiếm chỗ thật thì vách ngày sau mới đẩy được vách
       ngày trước ra khỏi mép trên. Cao 0px là dính lại vĩnh viễn. -->
  <li class="sticky top-1 z-20 flex justify-center py-1 mb-1">
    <span
      class="px-3 py-1 text-xs rounded-full shadow-sm bg-n-slate-3 text-n-slate-11"
    >
      {{ label }}
    </span>
  </li>
</template>
